// extracted by mini-css-extract-plugin
module.exports = {"root":"TimeDefinition-module__root__2Woli"};